import {
  QUICKCASA_PRIVACY_POLICY_URL,
  QUICKCASA_TERMS_URL,
} from '../../_configuration/quickpass-configuration'

import { FooterRegion, LegalLink, Separator } from './styled'

/**
 * The app's standing link to its published legal documents.
 *
 * QuickPass asks renters for identity documents, bank balances and income, and
 * a privacy policy that only exists on the marketing site is not reachable by
 * the person actually being asked. This sits in the signed-in shell so the
 * policy is one tap away from every screen that collects anything, including
 * the bank connection.
 *
 * The links open in a new tab because the documents are on another origin and
 * a renter halfway through a verification should not lose their place to read
 * them.
 *
 * @returns {JSX.Element}
 */
const LegalFooter = (): JSX.Element => {
  return (
    <FooterRegion>
      <LegalLink
        href={QUICKCASA_PRIVACY_POLICY_URL}
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy
      </LegalLink>
      <Separator aria-hidden="true">|</Separator>
      <LegalLink href={QUICKCASA_TERMS_URL} target="_blank" rel="noreferrer">
        Terms of Service
      </LegalLink>
    </FooterRegion>
  )
}

export default LegalFooter
